import { ResumeProcessStepRecordingRequestSchema, ResumeProcessStepRecordingResponseSchema } from './resume-process-step-recording.schema';
/**
 * Resume Process Step Recording Endpoint Contract
 * Transitions pending_finalization → in_progress so the user can edit the
 * recording again before stopping a second time. Generated fields are
 * preserved so a subsequent stop can short-circuit the AI call.
 */ export const resumeProcessStepRecordingContract = {
    method: 'POST',
    path: '/api/v2/process-step-recording/:id/resume-recording',
    description: 'Return a stopped recording to the in_progress state for further editing',
    requestSchema: ResumeProcessStepRecordingRequestSchema,
    responseSchema: ResumeProcessStepRecordingResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized',
            404: 'Step recording not found'
        }
    }
};

//# sourceMappingURL=resume-process-step-recording.contract.js.map